import { render, staticRenderFns } from "./bridge.vue?vue&type=template&id=48375a6c&scoped=true&"
import script from "./bridge.vue?vue&type=script&lang=js&"
export * from "./bridge.vue?vue&type=script&lang=js&"
import style0 from "./bridge.vue?vue&type=style&index=0&id=48375a6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48375a6c",
  null
  
)

export default component.exports